import Vue from 'vue'

export const bus = new Vue()



// WEBPACK FOOTER //
// ./src/bus.js